/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
/*if (document.getElementById('site-navigation') && document.getElementById('menu-main-menu-swedish')) {
  aucor_navigation(document.getElementById('menu-main-menu-swedish'), document.getElementById('menu-main-menu-swedish'), {
    desktop_min_width: 890, // min width in pixels
    menu_toggle: '#menu-toggle' // selector for toggle
  });
}*/
/*if (document.getElementById('site-navigation') && document.getElementById('menu-main-menu-english')) {
  aucor_navigation(document.getElementById('menu-main-menu-english'), document.getElementById('menu-main-menu-english'), {
    desktop_min_width: 890, // min width in pixels
    menu_toggle: '#menu-toggle' // selector for toggle
  });
}*/

/**
 * Responsive videos
 */
fitvids();

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}
